import React, { useContext, useRef, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';

import { withState } from '../../../../components/common/grid/WrappedGrid';
import { ROLES } from '~/src/utils/constants';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import { API_URL, DATE_FORMAT_WITH_TIME } from '../../../../utils/constants';
import { CreatedOnCell } from '../../../../components/common/grid/Cells';
import { grantedForRole, transformLabels } from '../../../../utils/misc';
import ButtonComponent from '~/src/components/common/forms/Button/ButtonComponent';
import FnbApi from '~/src/services/api/FnbApi';
import { StatusCodes } from 'http-status-codes';
import PullFnbOrders from '../components/PullFnbOrders';
import SyncFnbOrder from '../components/SyncFnbOrder';
import moment from 'moment';
import ConsolidateFnbOrders from '../components/ConsolidateFnbOrders';
import { FnbOrderGetWithItemsDto, FnbInvoiceGetDto } from 'svila-common';
import ResetFnbOrder from '../components/ResetFnbOrder';
import RolesDependent from '~/src/components/common/RolesDependent';
import MyContext from '~/src/services/context';
import CompleteFnbOrder from '../components/CompleteFnbOrder';
import { DateRangeFilterCell } from '~/src/components/common/grid/DateRangeFilterCell';
import GridWrapper from '~/src/components/common/GridWrapper';

export default function FnbInvoiceList() {
  const stateRef = useRef(null);
  const url = `${API_URL}/fnb-invoices/get`;
  const history = useHistory();
  const [resetStatus, setResetStatus] = useState(false);

  const StatefullGrid = withState(Grid, url);

  const CustomerNameCell = (row, ref) => {
    const { dataItem } = row;
    return (
      <td>
        <Link to="/orders/fnb/orderId">
          {dataItem.name} {dataItem.nameLast}
        </Link>
      </td>
    );
  };

  const NumberCell = (row, ref) => {
    const dataItem: FnbInvoiceGetDto = row.dataItem as FnbInvoiceGetDto;
    return (
      <td>
        <Link to={`/orders/fnb/${dataItem.fnbUniqueNumber}`}>{dataItem.fnbUniqueNumber}</Link>
      </td>
    );
  };
  const UniqueNumberCell = (row, ref) => {
    const dataItem: FnbInvoiceGetDto = row.dataItem as FnbInvoiceGetDto;
    return (
      <td>
        <Link to={`/orders/fnb-invoices/${dataItem.fnbUniqueNumber}`}>{dataItem.uniqueNumber}</Link>
      </td>
    );
  };

  const OrderNumberCell = (row, ref) => {
    const { dataItem } = row;
    return (
      <td>
        <Link to={`/orders/details/${dataItem?.order?.id}`} target="_blank">
          {dataItem?.order?.orderNumber}
        </Link>
      </td>
    );
  };

  const ConsolidationOrderCell = (row, ref) => {
    const { dataItem } = row;
    return (
      <td>
        <Link
          to={`/orders/details/${dataItem?.order?.consolidationParentOrder?.id}/${dataItem?.consolidated}`}
          target="_blank"
        >
          {dataItem?.order?.consolidationParentOrder?.orderNumber}
        </Link>
      </td>
    );
  };

  const PriceCell = (row, ref) => {
    const { dataItem } = row;
    return <td>{`${dataItem.total} лв.`}</td>;
  };

  const PaymentMethodCell = (row, ref) => {
    const { dataItem } = row;
    return <td>{transformLabels(dataItem.paymentMethod)}</td>;
  };

  const StatusCell = (row, ref) => {
    const { dataItem } = row;
    return <td>{transformLabels(dataItem.statusTxt)}</td>;
  };

  const ActionCell = (row, ref) => {
    const { dataItem } = row;
    return (
      <td>
        <SyncFnbOrder onUpdate={UpdateTable} dataItemId={dataItem.id} />
        {dataItem.consolidated ? <span>Consolidated</span> : null}
        <CompleteFnbOrder onUpdate={UpdateTable} dataItemId={dataItem.uniqueNumber} />
      </td>
    );
  };

  const SyncCell = (row, ref) => {
    const { dataItem } = row;
    let lastSync;
    if (dataItem?.items?.length > 0) {
      lastSync = dataItem?.modifiedOn
        ? moment(dataItem?.modifiedOn).format(DATE_FORMAT_WITH_TIME)
        : moment(dataItem?.createdOn).format(DATE_FORMAT_WITH_TIME);
    } else {
      lastSync = '--';
    }
    return <td>{lastSync}</td>;
  };

  const ReservationCell = (row, ref): JSX.Element => {
    const { dataItem }: { dataItem: FnbOrderGetWithItemsDto } = row;
    return <td>{dataItem.fnbItemReservationStatus}</td>;
  };

  const context = useContext(MyContext);
  const roles = [ROLES.ADMIN, ROLES.SUPER_ADMIN];
  const permissionGranted = grantedForRole(roles, context.user?.role);

  const UpdateTable = () => {
    stateRef?.current?.update();
  };

  return (
    <WhitePad isFluid>
      <TitleComponent
        onLeftHandler={(): void => {
          history.push(`/home`);
        }}
        title="FNB"
      />
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn
            field="orderDate"
            title="Дата"
            cell={CreatedOnCell}
            filterCell={DateRangeFilterCell}
            width={200}
          />
          <GridColumn
            field="invoiceDate"
            title="Дата"
            cell={CreatedOnCell}
            filterCell={DateRangeFilterCell}
            width={200}
          />
          <GridColumn field="fnbUniqueNumber" title="FNB #" cell={NumberCell} />
          <GridColumn field="uniqueNumber" title="Invoice #" cell={UniqueNumberCell} />
          <GridColumn field="receiverFirstName" title="Клиент" />
          <GridColumn field="receiverLastName" title="Клиент" />
          <GridColumn field="paymentMethod" title="Метод на плащане" />
          <GridColumn field="ReceoverCity" title="Град за доставка" />
          <GridColumn field="total" title="Сума" cell={PriceCell} />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
